export interface IState {
  boat: { _id: string; name: string };
}

interface SetBoatAction {
  type: "SET_BOAT";
  payload: { _id: string; name: string };
}

type Action = SetBoatAction;

export const boatsReducer = (
  state: IState = {
    boat: { _id: "", name: "" },
  },
  action: Action
): IState => {
  switch (action.type) {
    case "SET_BOAT":
      return {
        ...state,
        boat: action.payload,
      };
    default:
      return state;
  }
};
